<ng-content></ng-content>
<nav #menu class="third-nav-tab" *ngIf="elements.length>0">
  <!-- Desktop  -->
  <ng-container *ngIf="isMobile==false && isTablet==false">
    <nav class="column">
      <ng-container *ngFor="let element of getArrayCopy(); let i = index">
        <ng-container *ngIf="(i < maxElements) && (i !== changedIndex)">
          <a *ngIf="element.external == null;else viewExternalRouteDesktop"
          [preserveFragment]="true"
          [routerLinkActiveOptions]="{ exact: element.mustBeFullCheck }"
          [routerLinkActive]="['active']"
          [queryParamsHandling]="'merge'"
          [routerLink]="element.external == null ? (element.route ? element.route : '') : undefined"
             (click)="selectIndex(i); (element.onClick ? element.onClick : undefined)">
             {{element.name | transloco}}</a>
          <ng-template #viewExternalRouteDesktop>
            <a

            [href]="element.external ? element.route : undefined"
            [target]="element.external ? '_blank' : undefined"
            >
               {{element.name | transloco}}
               <div class="external-link"></div>

              </a>
          </ng-template>
        </ng-container>

      </ng-container>
      <ng-container  *ngIf="selectedIndex > maxElements-1" >
        <a
          *ngIf="elements[selectedIndex].external == null;else routeDesktopView"
          [queryParamsHandling]="'merge'"
          [routerLinkActiveOptions]="{ exact: element.mustBeFullCheck }"
          [preserveFragment]="true"
          [routerLinkActive]="['active']"

          [routerLink]="elements[selectedIndex].external == null ? (elements[selectedIndex].route ? elements[selectedIndex].route : '') : undefined"
        (click)="(elements[selectedIndex].onClick ? elements[selectedIndex].onClick : undefined);selectIndex(selectedIndex);">

        {{elements[selectedIndex].name | transloco}}</a>
        <ng-template #routeDesktopView>
          <a
          [href]="elements[selectedIndex].external ? elements[selectedIndex].route : undefined"
          [target]="elements[selectedIndex].external ? '_blank' : undefined"
        >

        {{elements[selectedIndex].name | transloco}}
        <div class="external-link"></div>

      </a>
        </ng-template>
      </ng-container>

        <a *ngIf="elements.length > maxElements" class="menuDesp" (click)="toggleVisibility()">
          <mat-icon>view_headline</mat-icon></a>
    </nav>
  </ng-container>

  <nav *ngIf="visibility===true && isMobile==false && isTablet==false" class="collapse-menu" [@heightAnimation]="heightAnimationState">
    <ng-container *ngFor="let element of elements; let i = index">
      <div class="collapse-menu-items" [@opacityAnimation]="slideAnimationState" *ngIf="i >= maxElements ||  (changedIndex === i)">
        <ng-template #hideExternalRouteDesktop >
          <a

          [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="{ exact: element.mustBeFullCheck }"

          [href]="element.external ? element.route : undefined"
          [target]="element.external ? '_blank' : undefined"
          >        {{element.name | transloco}}
          <div class="external-link"></div>

        </a>
        </ng-template>
        <a
        [queryParamsHandling]="'merge'"
        [routerLinkActive]="['active']"
        [preserveFragment]="true"
        *ngIf="element.external == null;else hideExternalRouteDesktop"
        (click)="selectIndex(i); (element.onClick ? element.onClick : undefined)"
        [routerLink]="element.external == null ? (element.route ? element.route : '') : undefined"
        >
        {{element.name | transloco}}
      </a></div>
    </ng-container>
  </nav>
  <!-- End Desktop  -->

  <!-- Tablet  -->
  <ng-container *ngIf="isTablet==true && isMobile==false">
    <nav class="column">
      <ng-container *ngFor="let element of elements; let i = index">
        <ng-container *ngIf="selectedIndex===0 || selectedIndex===1">
          <ng-container  *ngIf="(i < maxElementsTablet)">
            <a
            *ngIf="element.external == null; else externalRouteTable"
            [routerLinkActive]="['active']"
            [queryParamsHandling]="'merge'"
            [routerLinkActiveOptions]="{ exact: element.mustBeFullCheck }"
            [preserveFragment]="true"
            [routerLink]="element.external == null ? (element.route ? element.route : '') : undefined"
               (click)="selectIndex(i); (element.onClick ? element.onClick : undefined)">{{element.name | transloco}}</a>
            <ng-template #externalRouteTable>
              <a

              [href]="element.external ? element.route : undefined"
              [target]="element.external ? '_blank' : undefined"
                 >{{element.name | transloco}}
                 <div class="external-link"></div>
                </a>
            </ng-template>

          </ng-container>

        </ng-container>
        <ng-container *ngIf="selectedIndex>1">
          <ng-container *ngIf="(i < maxElementsTablet - 1) || i===selectedIndex">
            <a
            *ngIf="element.external == null;else externalRouteTabletSelected"
            [routerLinkActive]="['active']"
            [queryParamsHandling]="'merge'"
            [routerLinkActiveOptions]="{ exact: element.mustBeFullCheck }"
            [preserveFragment]="true"
            [routerLink]="element.external == null ? (element.route ? element.route : '') : undefined"
            [href]="element.external ? element.route : undefined"
              [target]="element.external ? '_blank' : undefined"
               (click)="selectIndex(i); (element.onClick ? element.onClick : undefined)">{{element.name | transloco}}</a>
               <ng-template #externalRouteTabletSelected>
                <a
                [routerLinkActive]="['active']"
                [href]="element.external ? element.route : undefined"
                  [target]="element.external ? '_blank' : undefined"
                   >{{element.name | transloco}}
                   <div class="external-link"></div>
                  </a>

               </ng-template>
          </ng-container>
        </ng-container>
      </ng-container>
      <a *ngIf="elements.length > maxElementsTablet" class="menuDesp" (click)="toggleVisibility()">
        <mat-icon>view_headline</mat-icon></a>
    </nav>
  </ng-container>

  <nav *ngIf="visibility===true && isTablet==true && isMobile==false" class="collapse-menu" [@heightAnimation]="heightAnimationState">
    <ng-container *ngFor="let element of elements; let i = index">
      <div class="collapse-menu-items"
      [@opacityAnimation]="slideAnimationState"
      *ngIf="(i >= maxElementsTablet ||  (changedIndex === i))">
      <ng-container>
        <a
         *ngIf="element.external == null; else viewTabletHiddenExternal"
        (click)="selectIndex(i); (element.onClick ? element.onClick : undefined)"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: element.mustBeFullCheck }"
        [preserveFragment]="true"
         [queryParamsHandling]="'merge'"

         [routerLink]="element.external == null ? (element.route ? element.route : '') : undefined"
        >
        {{element.name | transloco}}
      </a>
      <ng-template #viewTabletHiddenExternal>
        <a
         [href]="element.external ? element.route : undefined"
         [target]="element.external ? '_blank' : undefined"
        >

        {{element.name | transloco}}
        <div class="external-link"></div>

      </a>
      </ng-template>
      </ng-container>
</div>
    </ng-container>
  </nav>
  <!-- End Tablet  -->

  <!-- Mobile  -->
  <ng-container *ngIf="isMobile==true && isTablet==false">
    <nav class="column">
      <ng-container *ngFor="let element of getArrayCopy(); let i = index">
        <a *ngIf="(i === selectedIndex)"
        [routerLinkActive]="['active']"

        [routerLinkActiveOptions]="{ exact: element.mustBeFullCheck }"
        [queryParamsHandling]="'merge'"
        [preserveFragment]="true"
        [routerLink]="element.external == null ? (element.route ? element.route : '') : undefined"
        [href]="element.external ? element.route : undefined"
        [target]="element.external ? '_blank' : undefined"
           (click)="selectIndex(i); (element.onClick ? element.onClick : undefined)">{{element.name | transloco}}</a>
      </ng-container>
      <a *ngIf="elements.length > 1" class="menuDesp" [ngClass]="{'opened': visibility}" (click)="toggleVisibility()">
        <mat-icon>view_headline</mat-icon></a>
    </nav>
  </ng-container>

  <nav *ngIf="visibility===true && isMobile==true && isTablet==false" class="collapse-menu" [@heightAnimation]="heightAnimationState">
    <ng-container *ngFor="let element of elements; let i = index">
      <div class="collapse-menu-items" [@opacityAnimation]="slideAnimationState">
        <a
        *ngIf="element.external == null; else MobileHiddenExternal"
        (click)="selectIndex(i); (element.onClick ? element.onClick : undefined)"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: element.mustBeFullCheck }"
        [queryParamsHandling]="'merge'"
        [preserveFragment]="true"
        [routerLink]="element.external == null ? (element.route ? element.route : '') : undefined"
        >
        {{element.name | transloco}}
      </a>
      <ng-template #MobileHiddenExternal>
        <a
        [href]="element.external ? element.route : undefined"
        [target]="element.external ? '_blank' : undefined"
        >
        {{element.name | transloco}}
        <div class="external-link"></div>

      </a>
      </ng-template>

    </div>
    </ng-container>
  </nav>
  <!--End  Mobile  -->
</nav>
